import React from 'react'
import styles from "../components/laymanComp_css/LaymanPage36.module.css"
import { Link } from '@mui/material'

export default function LaymanPage36() {
  return (
    <>
      <div className={styles.layman_block_2}>
        <div className={styles.block1_main_wrpr}>
          <div className={styles.block1_main_bg}>
            <div className={styles.common_width_1}>
              <div className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle}`}>
                <div className={styles.column}>
                  <div className={`${styles.col12} ${styles.bgifive}`}>
                    <h1>ARCHETYPE OF SCORPIO</h1>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.common_width}>
              <div className={styles.om_block_main}>
                <div
                  className={`${styles.om_block1_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/scorpio/scorpio_1img.webp" /> */}
                    <img  src={`${process.env.cloud_url}Layman-Symbolism/scorpio/scorpio_1img.webp`}/> 

                  </div>
                  {/* className={styles.yellow_txt} */}
                  <div className={styles.layman_txt_box_wrpr}>
                    <div className={styles.layman_txt_box_innr}>
                      <div className={styles.layman_yellow_commn_header}>
                        <h2>The Depths of Scorpio: Navigating the Waters of Transformation</h2>
                      </div>
                      <p>
                        In the intricate tapestry of <Link href="https://www.divineinfinitebeing.com">the School of Divine Infinite Being</Link> method and Archetypal Astrology,
                        Scorpio emerges as a Cosmic Archetype, a Fixed Water Influence that delves into the profound
                        realms of passion, loyalty, and transformative power.

                      </p>
                      <p><b>
                        The Essence of Scorpio

                      </b></p>
                      <p>
                        <b>Fixed Water Influence:</b> Scorpio, as a Fixed Water Influence, represents the ground state of blind
                        loyalty and deep passion. Rooted in the physical body's orgiastic energy, Scorpio surfaces the most potent emotions within us, offering the potential for profound transformation. It is the archetype of both intense tragedy and the unwavering love of a mother willing to sacrifice for her offspring.
                      </p>
                      <p><b>
                        The Power of Death
                      </b></p>
                      {/* <div className={styles.layman_yellow_commn_header}>
                        <h2>The Symbolic Essence of OM:</h2>
                      </div> */}
                      <p>
                        <b>Thoth Tarot - Death:</b> The symbolism in the Death card of the Thoth Tarot unfolds a gripping narrative. A scorpion, caught in a ring of fire, turns its stinger on itself, choosing a symbolic death. This act
                        heralds the beginning of knowledge, portrayed by a serpent shedding its skin. At the apex of the card, an eagle gains new insights, surveying the landscape from an elevated perspective.
                      </p>
                      <p><b>
                        Embracing Transformation

                      </b></p>
                      <p>

                        <b>Inviting Death:</b> To work under the influence of Scorpio is to invite death—a symbolic death that
                        empowers emotional convictions, allowing us to release that which no longer serves us. The Scorpio
                        Archetype beckons us to navigate the waters of transformation, shedding old skins to make way
                        for new growth.
                      </p>


                    </div>
                  </div>
                </div>
                <div
                  className={`${styles.om_block2_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img
                      className={styles.orphic_egg_img1}
                      src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/scorpio/scorpio_2img.webp"
                    /> */}
                    <img   className={styles.orphic_egg_img1} src={`${process.env.cloud_url}Layman-Symbolism/scorpio/scorpio_2img.webp`}/> 

                  </div>

                  <div className={styles.layman_txt_box_wrpr}>
                    <div className={styles.layman_txt_box_innr}>
                      {/* <div className={styles.layman_yellow_commn_header}>
                        <h2>The Vibration and Chanting:</h2>
                      </div> */}
                      <p><b>Passion and Conviction</b></p>
                      <p>
                        <b>Unbridled Emotion:</b> Scorpio's unbridled emotion is the wellspring of our deepest convictions and
                        passions. It is the force behind both tragic actions and the selfless protection of loved ones. Scorpio's influence heightens our commitment to our families and the broader human race.

                      </p>
                      <p><b>The Dance of Release and Renewal</b></p>

                      <p>
                        <b>Symbolic Death and Knowledge:</b> In Scorpio's dance, symbolic death leads to profound knowledge—the shedding of old patterns, beliefs, and attachments. The archetype encourages us to embrace change and surrender to the transformative power of our emotions.
                      </p>


                      <p><b>Scorpio and the Alchemy of Emotions</b></p>
                      <p>
                        <b>Emotional Alchemy:</b> Scorpio's influence is an alchemical process that transmutes the base metal of intense emotions into the gold of self-awareness and renewal. It teaches us the art of letting go,
                        allowing for the continual cycle of death and rebirth.
                      </p>
                      <p>
                        <b>Conclusion</b>
                      </p>
                      <p>
                        In the enigmatic depths of Scorpio, we find a cosmic force that urges us to confront our deepest
                        emotions, release that which binds us, and emerge renewed. Like the scorpion embracing symbolic death to gain knowledge, Scorpio beckons us to navigate the waters of transformation and embrace the alchemy of our emotions.
                      </p>





                    </div>
                  </div>
                </div>
                <div
                  className={`${styles.om_block3_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/scorpio/scorpio_3img.webp" /> */}
                    <img src={`${process.env.cloud_url}Layman-Symbolism/scorpio/scorpio_3img.webp`}/> 

                  </div>

                  <div className={`${styles.layman_txt_box_wrpr} ${styles.bullet_cont}`}>

                    <div className={styles.layman_txt_box_innr}>
                      <div className={styles.layman_yellow_commn_header}>
                        <h2>Astrological Features:</h2>
                      </div>
                      <p>
                        <b>Cosmic Archetype:</b> Scorpio is a significant Cosmic Archetype within the framework of <Link href="https://www.divineinfinitebeing.com">the School of Divine Infinite Being</Link> method and Archetypal Astrology.
                      </p>

                      <p>

                        <b>Fixed Water Influence:</b> Scorpio embodies the Fixed Water Influence, representing deep passion, blind loyalty, and the orgiastic energy rooted in the physical body.

                      </p>
                      <p>
                        <b>Profound Emotions:</b> As a Fixed Water Influence, Scorpio surfaces the strongest emotions within individuals, providing the power for profound transformations and intense convictions.

                      </p>
                      <p>
                        <b>Thoth Tarot - Death:</b> In the Thoth Tarot, Scorpio is symbolized by the Death card, where a scorpion caught in a ring of fire chooses symbolic death, marking the beginning of knowledge and
                        shedding old skins.
                      </p>
                      <p>
                        <b>Eagle Symbolism:</b> The Death card also features an eagle at the top, gaining new insights and
                        perspectives, symbolizing the transformative power of Scorpio's influence.
                      </p>
                      <p>
                        <b>Symbolic Death and Knowledge:</b> Scorpio's influence invites individuals to embrace symbolic death, empowering emotional convictions, and leading to profound knowledge through shedding old patterns.
                      </p>
                      <p>
                        <b>Passion and Conviction:</b> Scorpio's unbridled emotion is the source of both intense tragedy and unwavering love, strengthening convictions and passions, particularly in familial and broader human relationships.

                      </p>
                      <p>
                        <b>Navigating Transformation:</b> To work under the influence of Scorpio is to navigate the
                        transformative waters, releasing that which no longer serves and embracing change for renewal.
                      </p>
                      <p>
                        <b>Emotional Alchemy:</b> Scorpio's influence acts as emotional alchemy, transmuting intense
                        emotions into self-awareness and renewal, emphasizing the continual cycle of death and rebirth.
                      </p>
                      <p>
                        <b>Release and Renewal:</b> The Scorpio archetype teaches the art of letting go, allowing for the
                        release of old attachments and beliefs, paving the way for continual cycles of release
                        and renewal.
                      </p>

                    </div>
                  </div>
                </div>
                {/* <div
                  className={`${styles.om_block4_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    <img
                      className={styles.orphic_egg_img1}
                      src=""
                    />
                  </div>

                  <div className={`${styles.layman_txt_box_wrpr} ${styles.bullet_cont}`}>
                    <div className={styles.layman_txt_box_innr}>
                      <p>
                        <b>Vigor of Statehood:</b> Aries, much like the Spartans, draws on the vigor of statehood,
                        recognizing the importance of maintaining dominion and authority.

                      </p>

                      <p>
                        <b>Conditioning through Discipline:</b> The violent warrior tendencies of Aries can be
                        conditioned through discipline and an ascetic life, much like the Spartan way of life.
                      </p>
                      <p>
                        <b>Hidden Madness and Bloodthirsty Energy:</b> Aries hides a dormant madness and <span className={styles.yellow_txt}>bloodthirsty energy,</span> ready to be unleashed when facing formidable enemies, whether external or internal.
                      </p>

                      <p>
                        <b>Set Your House in Order:</b> Working under the influence of Aries is akin to setting one's house
                        in order, ruling one's domain with authority and defending it fiercely.
                      </p>

                      <p>
                        <b>Challenge and Refinement:</b> Aries draws on challenge and refinement, encouraging
                        individuals to seek conquest, gain valuable possessions, and rid themselves of useless burdens.
                      </p>

                      <p>
                      <b>Emperor of Thoth :</b>  <span className={styles.yellow_txt}>The Emperor of Thoth</span> archetype invokes the impulse to create or destroy, ruling with the wisdom of kingship, embodying the essence of Aries.
                      </p>
                    
                    </div>
                  </div>
                </div> */}
              </div>
            </div>

            {/* =========================================greensec---------------------------------------------               */}

            <div className={styles.green_sec_cmn_main_wrp}>
              <div className={styles.common_width}>
                <Link href="/rota-the-wheel">
                  <div className={styles.green_sec_cmn_sub_wrp}>
                    <h1>The Astrological Tarot association for Scorpio  <br /> is The Death. See our alchemical ROTA here</h1>
                  </div>
                </Link>
              </div>
            </div>
            {/* ---------------------------------------------------greensec_end=================================== */}

            {/* <div className={styles.demo_image}>
              <div className={styles.block1_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_scorpio/layman_page36_block1_demo_img.webp'></img>
              </div>

              <div className={styles.block2_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_scorpio/layman_page36_block2_demo_img.webp'></img>
              </div>

              <div className={styles.block3_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_scorpio/layman_page36_block3_demo_img.webp'></img>
              </div>

              <div className={styles.block4_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_scorpio/layman_page36_block4_demo_img.webp'></img>
                <Link className={styles.blank_link} href="/rota-the-wheel"></Link>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  )
}